<template>
  <!-- eslint-disable vue/no-v-html -->
  <div
    class="copy-item"
    :style="backgroundStyles"
  >
    <h2
      class="copy-item__heading"
      :style="`color: ${copyItemHeadingColor}`"
      v-html="copyItemHeading"
    />
    <div class="copy-item__content" @click="handleLinkClick" v-html="copyItemHtml" />
  </div>
</template>

<script>

import handleLinkClick from '@/mixins/handle-link-click-mixin';

export default {
  name: 'CopyItem',
  mixins: [handleLinkClick],
  props: {
    copyItemBackgroundColor: {
      type: String,
      default: '',
    },
    copyItemHeading: {
      type: String,
      default: '',
    },
    copyItemHeadingColor: {
      type: String,
      default: '',
    },
    copyItemHtml: {
      type: String,
      default: '',
    },
    copyItemBackgroundImage: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    backgroundImage() {
      if (
        !this.copyItemBackgroundImage.featuredMedia
        || !this.copyItemBackgroundImage.featuredMedia[0]
      ) return null;

      return `url(${this.copyItemBackgroundImage.featuredMedia[0].url})`;
    },
    backgroundStyles() {
      return {
        backgroundColor: this.copyItemBackgroundColor,
        backgroundImage: this.backgroundImage,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '@/stylesheets/components/_copy-item';
</style>

<style lang="scss"> // no scoped - to reach HTML content
  .copy-item__content p {
    margin-bottom: $spacing * 3;
    line-height: 1.6;
  }
</style>

<docs>
</docs>
